import LegoUser from 'client/common/components/lego/user';

export default LegoUser;
